import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use((config) => {
    config.headers.Authorization = 'Basic ' + btoa(`${localStorage.getItem('token')}` + ':Bearer');
    return config;
});

instance.interceptors.response.use(
  (successfulReq) => successfulReq,
  (error) => Promise.reject(error)
);

export default {
  async get(path, options) {
    return await instance.get(path, options); 
  },

  async post(path, data, options) {
    return await instance.post(path, data, options); 
  },

  async put(path, data, options) {
    return await instance.put(path, data, options);
  },

  async delete(path, options) {
    return await instance.delete(path, options);
  },
};

export const getRequest = async (path, options) => {
  return await axios.get(path, options);
};

export const postRequest = async (path, data, options) => {
  return await axios.post(path, data, options);
};

export const putRequest = async (path, data, options) => {
  return await axios.put(path, data, options);
};

export const deleteRequest = async (path, options) => {
  return await axios.delete(path, options);
};
